import { defineCopy } from '@floorfile/i18n'
import { checksCopy } from './copy'

export const checksOfflineCopy = defineCopy('checks', { offlineAction: checksCopy.en.offlineAction })
